import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

import { FormSection } from '@/types/formSections.types';

type Props = {
  selectedSection: FormSection | null;
};

export const MainSectionStyled = styled.div<Props>`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  height: 100%;

  .mainSection {
    position: relative;

    &__form {
      overflow-y: auto;
      padding: ${props =>
        props.selectedSection === 'locations' || props.selectedSection === 'screens' ? '0' : '0 16px 16px 16px'};
      width: 100%;
      height: 100%;
      ${mixins.forceScrollbar as any}
    }
  }
`;
